import { render, staticRenderFns } from "./marketing-kongkim.vue?vue&type=template&id=dbc5bc9e&scoped=true&"
import script from "./marketing-kongkim.vue?vue&type=script&lang=js&"
export * from "./marketing-kongkim.vue?vue&type=script&lang=js&"
import style0 from "./marketing-kongkim.vue?vue&type=style&index=0&id=dbc5bc9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc5bc9e",
  null
  
)

export default component.exports